import {
  BankOutlined,
  GoldOutlined,
  AccountBookOutlined,
  UserOutlined,
  ApiOutlined,
  ApartmentOutlined,
  AppstoreOutlined,
  ContainerOutlined,
  ShopOutlined,
  ShoppingOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import React from "react";

const selectableIcons = {
  shop: <BankOutlined />,
  product: <GoldOutlined />,
  order: <ContainerOutlined />,
  billing: <AccountBookOutlined />,
  user: <UserOutlined />,
  account: <ApartmentOutlined />,
  "user.pointRule": <GoldOutlined />,
  "user.userPoint": <GoldOutlined />,
  "user.pointDetail": <GoldOutlined />,
  "system.pointGrantAllowlist": <UserOutlined />,
  cost: <DollarOutlined />,
  resource: <BankOutlined />,
  device: <ApiOutlined />,
  system: <AppstoreOutlined />,
  wxShop: <ShopOutlined />,
  generic: <ApartmentOutlined />,
};

const MenuIcon = {
  ...selectableIcons,
  "wxShop.product": <ShoppingOutlined />,
  "wxShop.ZTProduct": <GoldOutlined />,
  "wxShop.pointMall": <ShoppingOutlined />,
  "wxShop.container": <ContainerOutlined />,
  "wxShop.containerOrders": <ContainerOutlined />,
  "product.couponBundle": <GoldOutlined />,
};

const ICON_LABELS = {
  shop: '门店',
  product: '产品',
  order: '订单',
  billing: '结算',
  user: '用户',
  account: '账户',
  resource: '资源',
  device: '设备',
  system: '系统',
  wxShop: '小店',
  cost: '成本',
  generic: '通用',
}

export const MENU_ICON_OPTIONS = Object.keys(selectableIcons).map((value) => ({
  value,
  label: ICON_LABELS[value],
  icon: selectableIcons[value],
}))

export const getMenuIcon = (iconKey, legacyCode) =>
  selectableIcons[iconKey] || MenuIcon[legacyCode] || selectableIcons.generic

export default MenuIcon;
